function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{opacity:0.8;}.b{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-7474.915 -2236.245)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M5593.009,3131.53h-18.524v-11.967a.492.492,0,1,0-.983,0v12.459a.492.492,0,0,0,.492.492h19.016a.492.492,0,1,0,0-.984Z",
  transform: "translate(1901.414 -879.826)"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M5589.951,3126.859a.491.491,0,0,0-.671-.06l-4.59,3.606a.492.492,0,1,0,.608.773l4.226-3.32,2.316,2.6a.489.489,0,0,0,.346.165.482.482,0,0,0,.359-.134l5.072-4.79v1.482a.492.492,0,0,0,.984,0v-2.623a.488.488,0,0,0-.029-.16c0-.006,0-.011-.005-.017a.494.494,0,0,0-.1-.153s0,0,0-.007l0,0a.494.494,0,0,0-.151-.107l-.008,0a.48.48,0,0,0-.171-.039h-2.647a.492.492,0,0,0,0,.984h1.386l-4.634,4.376Z",
  transform: "translate(1894.02 -883.186)"
})),
/*#__PURE__*/
React.createElement("rect", {
  className: "b",
  width: 20,
  height: 20
}));

var SvgPerformance = function SvgPerformance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgPerformance, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Performance.7a922188.svg";
export { ForwardRef as ReactComponent };